// get default data from config file
import configData from '../../config'
// method to format date
import formatDate from './../../scripts/reusable/format-date'
// method to group elements in array
import * as dateRanges from '../reusable/group-date-ranges'
// get string parser
import * as fqParser from '../reusable/fq-parser'

const dataSearchDefault = configData().params.search.default
const facetDefault = configData().solr.filters

const state = {
  dateRange: {
    from: '',
    to: '',
    count: 0
  },
  dateRangeSet: {
    from: '',
    to: ''
  },
  dateRangeActive: {
    from: '',
    to: ''
  },
  dateValid: {
    from: true,
    to: true
  },
  // helper array when click through the date ranges
  dateArr: [],
  dateStart: '',
  dateEnd: '',
  isDateCheck: true,
  isDateSet: false,
  dateGap: facetDefault.facet_date_gap,
  facetDateRanges: []
}

const getters = {
  GET_DATE_FROM: state => {
    return state.dateRange.from
  },
  GET_DATE_TO: state => {
    return state.dateRange.to
  },
  GET_DATE_COUNT: state => {
    return state.dateRange.count
  },
  GET_DATE_FROM_STATIC: state => {
    return state.dateRangeSet.from
  },
  GET_DATE_TO_STATIC: state => {
    return state.dateRangeSet.to
  },
  GET_DATE_FROM_ACTIVE: state => {
    return state.dateRangeActive.from
  },
  GET_DATE_TO_ACTIVE: state => {
    return state.dateRangeActive.to
  },
  GET_DATE_START: state => {
    return state.dateStart
  },
  GET_DATE_END: state => {
    return state.dateEnd
  },
  GET_IS_DATE_SET: state => {
    return state.isDateSet
  },
  GET_IS_DATE_CHECK: state => {
    return state.isDateCheck
  },
  GET_FACET_DATE_RANGES: state => {
    return state.facetDateRanges
  },
  GET_DATE_GAP: state => {
    return state.dateGap
  },
  GET_DATE_ARR: state => {
    return state.dateArr
  },
  GET_VALID_DATE_FROM: state => {
    return state.dateValid.from
  },
  GET_VALID_DATE_TO: state => {
    return state.dateValid.to
  }
}

const actions = {
}

const mutations = {
  SET_DATE_FROM: (state, val) => {
    // sets chosen from date in state
    state.dateRange.from = val
  },

  SET_DATE_TO: (state, val) => {
    // sets chosen to date in state
    state.dateRange.to = val
  },

  SET_DATE_COUNT: (state, val) => {
    // sets number of results for set from and to date
    state.dateRange.count = val
  },

  SET_VALID_DATE_FROM: (state, val) => {
    state.dateValid.from = val
  },
  SET_VALID_DATE_TO: (state, val) => {
    state.dateValid.to = val
  },

  SET_CHECK_DATE: (state, val) => {
    state.isDateCheck = val
  },

  SET_DATE_FROM_STATIC: (state, val) => {
    // sets chosen from date in state
    state.dateRangeSet.from = val
  },

  SET_DATE_TO_STATIC: (state, val) => {
    // sets chosen to date in state
    state.dateRangeSet.to = val
  },

  SET_DATE_FROM_ACTIVE: (state, val) => {
    // sets daterange active from date in state
    state.dateRangeActive.from = val
  },

  SET_DATE_TO_ACTIVE: (state, val) => {
    // sets daterange active to date in state
    state.dateRangeActive.to = val
  },

  SET_FACET_DATE_RANGES: (state, data) => {
    state.facetDateRanges = dateRanges.groupDateRanges(data)
  },

  SET_TO_DATE_ARR: (state, val) => {
    let dateStart = state.dateStart
    let dateEnd = state.dateEnd

    let dateArr = state.dateArr

    let dateValueStart = val.start
    let dateValueEnd = val.end

    // prevent typing twice the same date (or words in input date)
    if (!(dateValueStart == dateStart && dateValueEnd == dateEnd) && ((dateArr.length == 0) || (dateArr.length > 0 && !(dateArr[dateArr.length-1].start == val.start && dateArr[dateArr.length-1].end == val.end)))) {
      dateArr.push(val)
    }
  },

  RESET_DATE_ARR: (state, val) => {
    state.dateArr = []
  },

  POP_FROM_DATE_ARR: (state, val) => {
    state.dateArr.pop()

    if (state.dateArr.length > 0) {
      // takes last element from date array and puts values to current chosen date range
      let obj = state.dateArr[state.dateArr.length - 1]
      state.dateRange.from = obj.start
      state.dateRange.to = obj.end
      state.dateRangeActive.from = obj.start
      state.dateRangeActive.to = obj.end

    } else {
      // sets current date to default or values set in filter
      state.dateRange.from = state.dateRangeSet.from == '' ? state.dateStart : state.dateRangeSet.from
      state.dateRange.to = state.dateRangeSet.to == '' ? state.dateEnd : state.dateRangeSet.to
      state.dateRangeActive.from = state.dateRangeSet.from == '' ? state.dateStart : state.dateRangeSet.from
      state.dateRangeActive.to = state.dateRangeSet.to == '' ? state.dateEnd : state.dateRangeSet.to
    }
    state.dateGap = dateRanges.setDateGap({ start: state.dateRange.from, end: state.dateRange.to})
  },

  RESET_DATE_RANGE: (state) => {
    // resets date
    state.dateRange.from = ''
    state.dateRange.to = ''
    state.dateRangeActive.from = ''
    state.dateRangeActive.to = ''
    state.isDateSet = false
    state.dateGap = dateRanges.setDateGap({ start: state.dateStart, end: state.dateEnd})
    state.dateArr = []
  },

  SET_DATE_START: (state, data) => {
    // default value for start
    state.dateStart = formatDate(data.stats.stats_fields.date_start.min)
  },

  SET_DATE_END: (state, data) => {
    // default value for end
    state.dateEnd = formatDate(data.stats.stats_fields.date_end.max)
  },

  SET_DATE_GAP: (state, data) => {
    // set date gap for facet ranges
    state.dateGap = dateRanges.setDateGap(data)
  },

  SET_DATE_RANGE_RES: (state, data) => {
    let fq = data.responseHeader.params.fq

    // date range is set to default
    state.dateRange.from = state.dateStart
    state.dateRange.to = state.dateEnd

    // reset date ranges in set facets
    state.dateRangeSet.from = ''
    state.dateRangeSet.to = ''

    // date is not set
    state.isDateSet = false

    function setFilter(value) {
      // check if it is date filter
      let name = fqParser.parseResStringName(value)
      if (name == 'date') {
        let obj = fqParser.parseStringDate(value, name)
        // dynamic date range in store
        state.dateRange.from = obj.from
        state.dateRange.to = obj.to

        // static values to only display current date range
        state.dateRangeSet.from = obj.from
        state.dateRangeSet.to = obj.to

        if(!state.isDateSet) {
          state.isDateSet = true
        }
      }
    }

    if (typeof fq !== typeof undefined) {
      if (typeof fq !== 'string') {
        fq.forEach(function(value) {
          setFilter(value)
        })
      } else {
        setFilter(fq)
      }
    }
  }
}

export {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/date-filters.js